import ArrowBackButton from "../../../components/button/ArrowBackButton"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import useFaqForm from "./useFaqForm"
import { Select } from "antd"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const FaqForm = () => {
    const {
        payload,
        onChangeHandler,
        postFaq,
        putFaq,
        getFaq,
        activeOptions,
        isSaving,
        handleSelectStatus,
    } = useFaqForm()
    const param = useParams()
    const [isUpdate, setUpdate] = useState(false)

    useEffect(() => {
        if (param.faq_id) {
            getFaq(param.faq_id)
            setUpdate(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [param.faq_id])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton 
                    title={isUpdate ? "Edit FAQ" : "Create FAQ"} 
                    isTwoSection={true}
                />
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    {isUpdate ? "Edit FAQ" : "Frequently Asked Questions Information"}
                </h5>

                <form onSubmit={(e) => {isUpdate ? putFaq(e): postFaq(e)}}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="Title" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Title <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="Title"
                                className="form-control" 
                                id="Title" 
                                placeholder="Enter Title" 
                                onChange={onChangeHandler}
                                value={payload && payload.Title}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="Answer" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Answer <span style={{color: 'red'}}>*</span>
                            </label>
                            <textarea
                                required
                                name="Answer"
                                className="form-control" 
                                id="Answer" 
                                placeholder="Enter Answer"
                                onChange={onChangeHandler}
                                value={payload && payload.Answer}
                                rows={5}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="Order" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Order <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="number" 
                                name="Order"
                                className="form-control" 
                                id="Order" 
                                placeholder="Enter Order" 
                                onChange={onChangeHandler}
                                value={payload && payload.Order}
                                style={{
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '16px'
                                }}
                            />
                        </div>

                        <div className="mb-0">
                            <label htmlFor="Active" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Active Status <span style={{color: 'red'}}>*</span>
                            </label>
                            <Select
                                required
                                allowClear
                                size="large"
                                style={{
                                    width: '100%'
                                }}
                                showSearch="true"
                                options={activeOptions}
                                placeholder="Select Active Status"
                                onChange={handleSelectStatus}
                                value={payload.Active}
                                fontSize="16px"
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save FAQ"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default FaqForm